import { useEditor } from '../state/store';
import { getTool } from '../tools/registry';
import { ToolId } from '../tools/types';
import { TOOL_ICONS } from './toolIcons';

/**
 * Full-width tool rows for the active section.
 *
 * Each row carries the tool's name and its shortcut, so the keyboard is
 * discoverable without a cheat sheet, and the selected tool is unmistakable.
 */
export function ToolPicker({ tools }: { tools: readonly ToolId[] }): JSX.Element {
  const active = useEditor((s) => s.tool);
  const setTool = useEditor((s) => s.setTool);

  return (
    <div className="group" style={{ gap: 5 }}>
      {tools.map((id) => {
        const tool = getTool(id);
        const Icon = TOOL_ICONS[id];
        return (
          <button
            key={id}
            className={`option${active === id ? ' active' : ''}`}
            onClick={() => setTool(id)}
            title={tool.hint}
          >
            <Icon size={16} strokeWidth={1.9} />
            <span className="label">{tool.name}</span>
            {tool.shortcut ? <span className="meta">{tool.shortcut}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
